import { initialAbility } from '@/libs/acl/config'

export default {
  methods: {
    logout() {
      this.$http.post('auth/logout').finally(() => {
        this.$store.commit('auth/setLoggedOut')
        this.$ability.update(initialAbility)
        this.$router.push({ name: 'login' }).then(() => {
          this.$store.commit('auth/clearAuthState')
        })
      })
      // this.$store.commit('auth/setLoggedOut')
      // this.$ability.update(initialAbility)
      // this.$router.push({ name: 'login' })
      //   .then(() => {
      //     this.$store.commit('auth/clearAuthState')
      //   })
    }
  },
}
